<div class="misuration-container">
  <!--<div class="card-container">
    @for (card of medicalCardData; track card.id) {
      <app-card-with-value [cardData]="card" (actionButtonEmitter)="addGraphValue($event, false)"></app-card-with-value>
    }
  </div>-->

  <h2>{{ 'misuration.trend_graphs' | translate }}</h2>
  <nz-divider></nz-divider>
  <div class="content-container" [hidden]="graphList.length <= 0">
    <!-- TODO Carosello -->
    <div class="filters-container">
      @for (filter of filtersGraph; track filter) {
        <div class="filter" [ngClass]="{ 'active-filter': activeFilterGraph === filter.id }" (click)="filterSelected(filter.id)">{{ filter.label }}</div>
      }
    </div>

    <div class="graph-container" [ngClass]="activeFilterGraph !== 'all' ? 'single' : null">
      @for (graph of graphConfig; track graph.id) {
        <div class="graph" [hidden]="activeFilterGraph !== 'all' && activeFilterGraph !== graph.id">
          <div class="header-graph-container">
            <span>{{ graph?.title }}</span>
            <ds-button
              text="{{ 'buttons.add_value' | translate }}"
              [iconRight]="'/public/assets/images/PlusCircleBlue.svg'"
              [styleType]="'undressed-main'"
              [width]="'small'"
              (click)="addGraphValue(graph.id, true)"
            ></ds-button>
          </div>
          <canvas [id]="graph.id"></canvas>
        </div>
      }
    </div>

    @if (activeFilterGraph !== 'all') {
      <div class="table-container">
        <h2>{{ 'misuration.history_misurations' | translate }}</h2>
        <nz-divider></nz-divider>
        <app-appointments-table
          [searchEnabled]="true"
          [hasCheckbox]="false"
          [hiddenLastSegment]="true"
          [columns]="columns"
          [appointments]="tableData[activeFilterGraph]"
          [appointmentText]="appointmentsText"
          (actionClicked)="openDeleteModal($event)"
        ></app-appointments-table>
      </div>
    }
  </div>
  @if (graphList.length === 0) {
    <p>{{ 'misuration.no_data' | translate }}</p>
  }
</div>
